import $ from 'jquery';
// R4 perf: removed dead `import handlebars from 'handlebars'`. The full
// handlebars runtime (~120 KB) was imported but never referenced. The .hbs
// template below is compiled at build time by handlebars-loader, which
// inlines a tiny runtime stub. Shared helpers live in
// common/js/handlebarHelper.js and use the much smaller `handlebars/runtime`
// build.
import CONSTANT from '../../common/js/_constant';
import compiledTemplate from './downloadFormComponent.hbs';
const downloadForm = {
    methods:{
        callServlet : async (el,path, value)=>{
            const apiUrl = `/bin/getPdfDetails?path=${encodeURIComponent(path+'/'+value)}`;
            $.ajax({
                url: apiUrl,
                method: 'POST',
                success: function(data) {
                    downloadForm.methods.dynamicHTML(el, data);
                },
                error: function(xhr, status, error) {
                    console.error('Error fetching PDF details:', status, error);
                    if (xhr.status === 403) {
                        console.error('Forbidden: You do not have permission to access this resource.');
                    }
                }
            });
        },
        handleSelection : (el)=>{
            const path = $(el).find('.language_select').find('select').data('parent-path');
            $(el).find('.language_select').find('select').on(CONSTANT.eventsListners.CHANGE, (e)=>{
                const optionValue = $(el).find('.language_select').find("select option:selected").val();
                downloadForm.methods.callServlet(el,path, optionValue);
            });
        },
        dynamicHTML : (el,data)=>{
            const htmlDisplay = $(el).find('#download-form-cmp__list-content');
            $(htmlDisplay).html('');
            $.each(data, (idx,item)=>{
                htmlDisplay.append(compiledTemplate({
                    path : item.path,
                    title: item.title,
                    mimeType: item.mimeType
                }));
            });
        },
          DownloadPdfClickHandler: function (){
          $('.download-form-cmp__list').on('click','.list-item.text-decoration-none',function () {
                let title = null;
                let container = $(this).closest('.download-form-cmp__container');
                if (container.find('.heading-3').first().length > 0) {
                 title = container.find('.heading-3').first().text().trim();
                }
                let text = $(this).find('.form-card__label');
                var obj = downloadForm.methods.dropdownDataLayerObj(null,title,text);
                let event = document.querySelector("input[name='pageType']") ? document.querySelector("input[name='pageType']").value == 'Product' ? "Download_Product" : "Download_NonProduct" : "Download_NonProduct";
                createDataLayer(event,obj);
            });
          },

          SelectDropdownItemClickHandler: function () {
              $('.language_select--select').on('change', function () {
                     let title = null;
                     let container = $(this).closest('.download-form-cmp__container');
                     if (container.find('.heading-3').first().length > 0) {
                       title = container.find('.heading-3').first().text().trim();
                     }
                     let text = $(this).find('option:selected').text().trim();
                    var obj = downloadForm.methods.dropdownDataLayerObj(text,title);
                    createDataLayer('Select_dropdown_item', obj);
              });
            },

            dropdownDataLayerObj: function (el,e,element) {
                  var obj = {
                    'articleName': "",
                    'blogCategory': "",
                    'blogPageCategory': "",
                    'buttonText': el ? el : element ? element.text().replace(/\s+/g, ' ').trim() : "",
                    'pageSection': e ? e : "Download Form Component",
                    'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com" ? "Home" : "Other Pages" : "Blog Details Page",
                    'planOption': "",
                    'productCategory': document.getElementById('productCategoryName') ? document.getElementById('productCategoryName').value : "",
                    'productName': document.getElementById('productPlanName') ? document.getElementById('productPlanName').value : "",
                    'question': "",
                    'source': "",
                    'leadForm': "",
                    'searchTerm': "",
                    'videoTitle': "",
                    'bannerName': "",
                  };
                  return obj;
                },

        init:function(){
            const handleSelection = this.handleSelection.bind(downloadForm);
            $('.download-form-cmp__wrapper').each((idx,el)=>{
                handleSelection(el);
            });
        }
    }
};
$(()=>{
    if($('.download-form-cmp__wrapper').length){
        downloadForm.methods.init();
    }
});
$(document).ready(function () {
  downloadForm.methods.SelectDropdownItemClickHandler();
  downloadForm.methods.DownloadPdfClickHandler();
});
